import { Card, Badge, Button, Group, Text, Stack, ActionIcon } from "@mantine/core";
import { IconBed, IconClock, IconDotsVertical } from "@tabler/icons-react";
import { motion } from "framer-motion";

const RatePlanCard = ({ plan, handleEdit, handleDelete }) => {

  const mealLabels = {
    none: "Aucun repas",
    breakfast: "Petit déjeuner",
    half_board: "Demi pension",
    full_board: "Pension complète"
  };

  return (

    <motion.div whileHover={{ y: -6 }} transition={{ duration: 0.2 }}>

      <Card shadow="sm" radius="lg" p="lg" withBorder>

        <Stack gap="md">

          {/* HEADER */}

          <Group justify="space-between">

            <Stack gap={2}>

              <Text fw={600} size="lg">
                {plan.name}
              </Text>

              <Group gap="xs">

                <IconBed size={16} />

                <Text size="sm" c="dimmed">
                  {plan.rooms?.length || 0} chambres
                </Text>

              </Group>

            </Stack>

            <ActionIcon variant="subtle" color="gray">
              <IconDotsVertical size={18} />
            </ActionIcon>

          </Group>

          {/* BADGES */}

          <Group>

            <Badge
              variant="light"
              color="green"
              leftSection={<IconClock size={14} />}
            >
              Annulation {plan.cancellationPolicy?.hoursBeforeArrival}h
            </Badge>

            <Badge variant="light" color="cyan">
              {mealLabels[plan.mealPlan]}
            </Badge>

          </Group>

          {/* ACTIONS */}

          <Group mt="xs">

            <Button
              size="xs"
              radius="md"
              color="green"
              onClick={() => handleEdit(plan)}
            >
              Modifier
            </Button>

            <Button
              size="xs"
              color="red"
              variant="light"
              radius="md"
              onClick={() => handleDelete(plan)}
            >
              Supprimer
            </Button>

          </Group>

        </Stack>

      </Card>

    </motion.div>
  );
};

export default RatePlanCard;